
import {
  checkRolePermission,
  formatInputNumberOnlyV2,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { getPhoneDisplayCode } from "@/app/infrastructures/misc/common-library/v2/FormatPhoneNumber";
import { PartnerController } from "@/app/ui/controllers/PartnerController";
import { PosController } from "@/app/ui/controllers/PosController";
import { ClientPartnerOptions } from "@/domain/entities/CnManifest";
import { debounce, values } from "lodash";
import { Options, Vue } from "vue-class-component";
import { CourierManagementController } from "@/app/ui/controllers/CourierManagementController";
import { ApiRequestCourierManagementCreate } from "@/data/payload/api/CourierManagementApiRequest";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import {
  ErrorMessageEntities,
  OptionsClass,
  SubData
} from "@/domain/entities/MainApp";
import {
  CourierListDevice,
  CourierManagementDetail,
  CourierDeliveries,
  District
} from "@/domain/entities/CourierManagement";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { COURIER_MANAGEMENT } from "@/app/infrastructures/misc/RolePermission";
import validatePlateNumber from "@/app/infrastructures/misc/common-library/ValidatePlateNumber";
import { ValidateMsisdn } from "@/app/infrastructures/misc/common-library/ValidateInputPhoneNumber";
import { FlagsMedusa } from "@/feature-flags/flags-misc-medusa";
import { FlagsPermissionCourierManagement } from "@/feature-flags/flags-permission-courier-management";
import Checkbox from "@/app/ui/components/check-box/index.vue";
import moment from "moment";
import { PartnerDetail } from "@/domain/entities/Partner";
import MultipleSelectSearchVirtualScroll from "@/app/ui/components/multiple-select-search-virtual-scroll/index.vue";
import CardPopupOtherTag from "@/app/ui/views/route/operational-area/component/ursa/card-popup-other-tag.vue";
import SelectPhoneCountry from "../../shipment/booking/component/select-phone-country.vue";
import { codePhoneCountry } from "@/app/ui/views/shipment/booking/booking-utils";

@Options({
  components: {
    Checkbox,
    MultipleSelectSearchVirtualScroll,
    CardPopupOtherTag,
    SelectPhoneCountry
  },
  watch: {
    $route(to, from) {
      if (this.isDetail || this.isEdit) {
        this.fetchDetail();
      }
      this.mappingAccountType();
    }
  }
})
class FormCourier extends Vue {
  deleteDataSelected = {} as any;

  get isEditable(): boolean {
    let haveAccess = false;
    switch (this.accountType) {
      case "pos":
      case "console":
      case "sub-console":
        haveAccess =
          FlagsMedusa.config_modify_courier_enable.isEnabled() &&
          !this.dataCourier.announcementCourierType.match(/kvp/gi);
        break;

      default:
        haveAccess = true;
        break;
    }
    return haveAccess && checkRolePermission(COURIER_MANAGEMENT.EDIT);
  }

  get isPosAccount() {
    return AccountController.accountData.isPosAccount;
  }

  mounted() {
    if (this.isDetail || this.isEdit) {
      this.fetchDetail();
      this.getDetailListDevice();
    } else {
      if (this.isPosAccount) {
        this.setActionDeliveryData({
          id: AccountController.accountData.account_type_detail?.id
        });
      }
      this.initPhoneCode();
    }
    this.initOptionLists();
    this.mappingAccountType();
    this.errorPhone.message = this.errorCaption.phoneNumber;
  }

  initOptionLists() {
    this.courierTypeList = this.getCourierTypeList();
    this.announcementCourierTypeList = this.getAnnouncementCourierTypeList();
    this.vehicleTypeList = this.getVehicleTypeList();
    this.bankList = this.getBankList();
  }

  mappingAccountType() {
    switch (this.accountType) {
      case "pos":
        this.dataCourier.courierType = "POS";
        this.dataCourier.announcementCourierType = "POS";
        this.dataCourier.vehicleType = "MOTORCYCLE";
        this.dataCourier.partner = new ClientPartnerOptions({
          partnerExternalCode:
            AccountController.accountData.account_type_detail
              .partnerExternalCode,
          name: AccountController.accountData.account_type_detail.company_name,
          partnerIsCodDelivery:
            AccountController.accountData.account_type_detail
              .partnerIsCodDelivery
        });
        this.partnerData = {
          label: this.$t("courierManagement.posName") as string,
          placeholder: this.$t(
            "courierManagement.placeholderPosName"
          ) as string,
          isDisabled: true
        };
        this.dataCourier.partnerType = "POS";
        this.disableOnSelectPartnerType = true;
        break;
      case "console":
      case "sub-console":
        this.dataCourier.courierType = "TRUCK";
        this.dataCourier.announcementCourierType = "TRUCK";
        this.dataCourier.vehicleType = "TRUCK";
        this.dataCourier.partner = new ClientPartnerOptions({
          partnerExternalCode:
            AccountController.accountData.account_type_detail
              .partnerExternalCode,
          name: AccountController.accountData.account_type_detail.company_name
        });
        this.partnerData = {
          label: this.$t("courierManagement.consolidatorName") as string,
          placeholder: "",
          isDisabled: true
        };
        break;
      default:
        this.partnerData = {
          label: this.$t("courierManagement.posName") as string,
          placeholder: this.$t(
            "courierManagement.placeholderPosName"
          ) as string,
          isDisabled: this.isEdit
        };
        break;
    }
  }

  get id(): string {
    return String(this.$route.params?.id);
  }
  get isDetail(): boolean {
    return !!(this.$route.name as string)?.match(/detail/i);
  }
  get isEdit() {
    return !!(this.$route.name as string)?.match(/edit/i);
  }
  get title(): string {
    if (this.isDetail) {
      return String(this.$route.params?.id);
    } else if (this.isEdit) {
      return this.$t("courierManagement.editDetailCourier") as string;
    }
    return this.$t("courierManagement.addCourier") as string;
  }

  get phonePrefix(): string {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.countryCode;
    return getPhoneDisplayCode(countryCode);
  }

  detailEntities = new ResponsePayloadV2();
  dataCourier = new CourierManagementDetail();
  detailDeviceEntites = new ResponsePayloadV2();
  dataDeviceCourier: any = [];
  modalConfirmLogout = false;
  disableOnSelectPartnerType = false;

  async getDetailListDevice() {
    try {
      this.detailDeviceEntites.loading = true;
      this.detailDeviceEntites = await CourierManagementController.getDetailListDevice(
        +this.id
      );
      this.dataDeviceCourier = this.detailDeviceEntites.data;
    } catch (error) {
      const errorEntities: ErrorMessageEntities = parsingErrorResponse(error);
      this.detailDeviceEntites.message = errorEntities.type;
    } finally {
      this.detailDeviceEntites.loading = false;
    }
  }
  async fetchDetail(): Promise<void> {
    try {
      this.detailEntities.loading = true;
      this.detailEntities = await CourierManagementController.getDetail(
        +this.id
      );
      this.dataCourier = this.detailEntities.data;
      this.courierStatusToggle = this.detailEntities.data.courierStatus.match(
        /^active/gi
      );
      if (this.isEdit) {
        const phone = codePhoneCountry(this.dataCourier.phoneNumber.replace("+", ""));
        this.phoneNumberCode = phone.code;
        this.dataCourier.phoneNumber = phone.number;
      }
      if (
        this.isEdit &&
        this.dataCourier.announcementCourierType.match(/kvp/i) &&
        this.accountType !== "internal"
      ) {
        this.goToCourierDetail();
      }
      if (this.isEdit && this.dataCourier.courierType === "POS") {
        this.setActionDeliveryData({
          id: this.isPosAccount
            ? AccountController.accountData.account_type_detail?.id
            : this.dataCourier.partnerId
        });
        if (this.dataCourier.courierAreaDeliveries.length) {
          this.dataCourier.courierAreaDeliveries.forEach(
            (item: CourierDeliveries) => {
              item.cityName = `${item.cityCode}-${item.cityName}`;
            }
          );
        }
      }
    } catch (error) {
      const errorEntities: ErrorMessageEntities = parsingErrorResponse(error);
      this.detailEntities.message = errorEntities.type;
    } finally {
      this.detailEntities.loading = false;
    }
  }
  get subData(): SubData {
    if (this.isDetail) {
      return new SubData({
        status: this.dataCourier.courierStatus,
        // isEditable: this.isEditable,
        isEditable: FlagsMedusa.config_modify_courier_enable.isEnabled(),
        goEdit: () => this.$router.push(`/courier-management/${this.id}/edit`)
      });
    }
    return new SubData({
      status: this.dataCourier.courierStatus
    });
  }

  async logoutDevice() {
    try {
      this.modalConfirmLogout = false;
      this.showModal = false;
      MainAppController.showLoading();
      await CourierManagementController.logoutDevice(
        this.deleteDataSelected.id
      );
      this.fetchDetail();
      this.getDetailListDevice();
      this.$toast.add({
        severity: "success",
        summary: this.$t("courierManagement.deleteDeviceSuccess") as string,
        iconClosePosition: "start",
        textColor: "black",
        life: 10000
      });
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("courierManagement.deleteDeviceFailed") as string
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  showModalConfirmLogout(data: any) {
    this.deleteDataSelected = data;
    this.modalConfirmLogout = true;
    this.showModal = true;
  }

  partnerType = "";
  isOpenCourierType = false;
  isOpenAnnouncementCourierType = false;
  isOpenVehicleType = false;
  isOpenBank = false;
  courierStatusToggle = false;
  courierTypeList: OptionsClass[] = [];
  announcementCourierTypeList: OptionsClass[] = [];
  vehicleTypeList: OptionsClass[] = [];
  bankList: OptionsClass[] = [];

  getCourierTypeList() {
    return [
      new OptionsClass({
        name: this.$t("courierManagement.placeholderDriverType") as string,
        value: ""
      }),
      new OptionsClass({
        name: "POS",
        value: "POS"
      }),
      new OptionsClass({
        name: "KVP",
        value: "KVP"
      }),
      new OptionsClass({
        name: this.$t("courierManagement.truck") as string,
        value: "TRUCK"
      })
    ];
  }

  getAnnouncementCourierTypeList() {
    return [
      new OptionsClass({
        name: this.$t(
          "courierManagement.placeholderAnnouncementCourierType"
        ) as string,
        value: ""
      }),
      new OptionsClass({
        name: "POS",
        value: "POS"
      }),
      new OptionsClass({
        name: "KVP",
        value: "KVP"
      }),
      new OptionsClass({
        name: this.$t("courierManagement.truck") as string,
        value: "TRUCK"
      })
    ];
  }

  getVehicleTypeList(withTruck = true) {
    const options = [
      new OptionsClass({
        name: this.$t("courierManagement.placeholderVehicleType") as string,
        value: ""
      }),
      new OptionsClass({
        name: this.$t("courierManagement.motorcycle") as string,
        value: "MOTORCYCLE"
      })
    ];

    if (withTruck) {
      options.push(
        new OptionsClass({
          name: this.$t("courierManagement.truck") as string,
          value: "TRUCK"
        })
      );
    }

    return options;
  }

  getBankList() {
    return [
      new OptionsClass({
        name: this.$t("courierManagement.placeholderBank") as string,
        value: ""
      }),
      new OptionsClass({
        name: "BCA",
        value: "BCA"
      }),
      new OptionsClass({
        name: "Maybank",
        value: "MAYBANK"
      }),
      new OptionsClass({
        name: "Mandiri",
        value: "MANDIRI"
      }),
      new OptionsClass({
        name: "BRI",
        value: "BRI"
      })
    ];
  }

  error = {
    phoneNumber: false,
    vehiclePlate: false,
    courierType: false,
    bankAccount: false
  };

  get errorCaption() {
    return {
      phoneNumber: this.$t("courierManagement.invalidPhone") as string,
      vehiclePlate: this.$t("courierManagement.invalidPlate") as string,
      bankAccount: this.$t("courierManagement.invalidBankAccount") as string,
      courierType: this.$t("courierManagement.courierTypeRequired") as string
    };
  }

  errorPhone = {
    error: false,
    message: ""
  };

  partnerData = {
    label: "",
    placeholder: "",
    isDisabled: false
  };

  showModal = false;
  isModalConfirmation = false;

  get dialogData() {
    if (this.isModalConfirmation) {
      return {
        title: this.$t("courierManagement.confirmSaveCourier") as string,
        message: this.$t(
          "courierManagement.confirmSaveCourierMessage"
        ) as string,
        image: "badge-confirmation-general",
        textSuccess: this.$t("courierManagement.save") as string,
        textCancel: this.$t("courierManagement.back") as string,
        onSuccess: this.onEditCourier,
        onClose: this.onCloseModal
      };
    } else if (this.isEdit) {
      return {
        title: this.$t("courierManagement.courierUpdateSuccess") as string,
        message: this.$t(
          "courierManagement.courierUpdateSuccessMessage"
        ) as string,
        image: "badge-success",
        textSuccess: this.$t("courierManagement.checkCourier") as string,
        onSuccess: this.goToCourierDetail
      };
    } else if (this.modalConfirmLogout) {
      return {
        title: this.$t("courierManagement.confirmDeleteDevice") as string,
        message: this.$t("courierManagement.confirmDeleteDeviceMessage", {
          deviceName: this.deleteDataSelected.deviceName,
          deviceOs: this.deleteDataSelected.deviceOs
        }) as string,
        image: "badge-confirmation-general",
        textSuccess: this.$t("courierManagement.delete") as string,
        textCancel: this.$t("courierManagement.cancel") as string,
        onSuccess: this.logoutDevice,
        onClose: this.onCloseModal
      };
    }
    return {
      title: this.$t("courierManagement.courierCreateSuccess") as string,
      message: this.$t(
        "courierManagement.courierCreateSuccessMessage"
      ) as string,
      image: "badge-success",
      textSuccess: this.$t("courierManagement.checkCourier") as string,
      onSuccess: this.goToCourierList
    };
  }

  get accountType() {
    if (AccountController.accountData.account_type === "partner") {
      return AccountController.accountData.account_type_detail.type;
    }
    return AccountController.accountData.account_type;
  }

  get isLoadingPartnerList() {
    return PosController.isLoading;
  }

  get isTruck() {
    return this.dataCourier.courierType.match(/^truck/gi);
  }

  get isKvp() {
    return this.dataCourier.courierType.match(/^kvp/gi);
  }

  get isFormValid() {
    const isDeliveriesValid =
      this.dataCourier.courierAreaDeliveries.length === 0 ||
      this.dataCourier.courierAreaDeliveries.every(
        (delivery) =>
          delivery.cityCode &&
          delivery.cityCode.trim() !== "" &&
          delivery.districts.length > 0
      );
    return (
      !!(
        this.dataCourier.fullname &&
        this.dataCourier.phoneNumber &&
        this.dataCourier.courierType &&
        this.dataCourier.announcementCourierType &&
        this.dataCourier.vehicleType &&
        this.dataCourier.vehiclePlate &&
        this.dataCourier.partner.partnerExternalCode &&
        ((this.dataCourier.bank.bankId &&
          this.dataCourier.bank.bankAccount &&
          this.dataCourier.bank.bankAccountName) ||
          this.isTruck)
      ) &&
      !(
        this.errorPhone.error ||
        this.error.bankAccount ||
        this.error.courierType ||
        this.error.vehiclePlate
      ) &&
      isDeliveriesValid
    );
  }

  get vehicleName(): string {
    const vehicle = this.vehicleTypeList.find(
      (v) => v.value === this.dataCourier.vehicleType
    );
    return vehicle ? vehicle.name : "";
  }

  onUpdateStatusCourier(value: boolean) {
    this.dataCourier.courierStatus = value ? "active" : "inactive";
  }

  onBack() {
    this.isEdit ? this.goToCourierDetail() : this.goToCourierList();
  }

  goToCourierList() {
    this.$router.push("/courier-management");
  }

  goToCourierDetail() {
    this.$router.push(`/courier-management/${this.id}`);
    this.onCloseModal();
    this.fetchDetail();
  }

  onOpenSelectCourierType() {
    this.isOpenCourierType = true;
  }

  onCloseSelectCourierType() {
    this.isOpenCourierType = false;
  }

  onSelectCourierType(key: string, value: string) {
    this.dataCourier.courierIsCod = false;
    switch (value) {
      case "POS":
      case "KVP":
        this.dataCourier.vehicleType = "MOTORCYCLE";
        this.vehicleTypeList = this.getVehicleTypeList(false);
        break;
      case "TRUCK":
        this.vehicleTypeList = [
          new OptionsClass({
            name: this.$t("courierManagement.placeholderVehicleType") as string,
            value: ""
          }),
          new OptionsClass({
            name: this.$t("courierManagement.truck") as string,
            value: "TRUCK"
          })
        ];
        this.dataCourier.vehicleType = "TRUCK";
        break;
      default:
        this.dataCourier.vehicleType = "";
        this.vehicleTypeList = this.getVehicleTypeList();
        break;
    }
    if (value === "") {
      this.partnerType = "";
      this.dataCourier.partnerType = "";
      this.disableOnSelectPartnerType = false;
    } else if (value === "POS") {
      this.partnerType = "pos";
      this.dataCourier.partnerType = "POS";
      this.disableOnSelectPartnerType = true;
      if (this.partnerDataList.id || this.partnerDataList.ownershipId) {
        this.setActionDeliveryData(this.partnerDataList);
      }
    } else {
      this.partnerType = "console";
      this.dataCourier.partnerType = this.$t(
        "courierManagement.console"
      ) as string;
      this.disableOnSelectPartnerType = true;
    }
    this.error.courierType = !value;
    this.dataCourier.courierType = value;
  }

  onOpenSelectAnnouncementCourierType() {
    this.isOpenAnnouncementCourierType = true;
  }

  onCloseSelectAnnouncementCourierType() {
    this.isOpenAnnouncementCourierType = false;
  }

  onSelectAnnouncementCourierType(key: string, value: string) {
    this.dataCourier.announcementCourierType = value;
  }

  onOpenSelectVehicleType() {
    this.isOpenVehicleType = true;
  }

  onCloseSelectVehicleType() {
    this.isOpenVehicleType = false;
  }

  onSelectVehicleType(key: string, value: string) {
    this.dataCourier.vehicleType = value;
  }

  onOpenSelectBank() {
    this.isOpenBank = true;
  }

  onCloseSelectBank() {
    this.isOpenBank = false;
  }

  onSelectBank(key: string, value: string) {
    this.dataCourier.bank.bankId = value;
  }

  partnerList: ClientPartnerOptions[] = [];
  filterPartnerList = debounce(async (search: string) => {
    const response = await PartnerController.fetchListPartnerOptions({
      page: 1,
      limit: 10,
      search: search,
      type: this.partnerType
    });
    this.partnerList = response;
  }, 250);

  formatPlateNumber(value: string) {
    return value.toUpperCase().replace(" ", "");
  }

  formatNumber(value: string) {
    return formatInputNumberOnlyV2(value);
  }

  get countryCode() {
    const countryCode =
      AccountController.accountData?.country_code ||
      AccountController.accountData?.account_type_detail?.countryCode;
    return getPhoneDisplayCode(countryCode);
  }

  initPhoneCode() {
    this.setPhoneCodeNumber(this.countryCode);
  }

  phoneNumberCode = "";

  setPhoneNumber(val: string) {
    this.dataCourier.phoneNumber = val;
    if (this.phoneNumberCode === "+62") {
      this.errorPhone.error = ValidateMsisdn(val).error;
    } else {
      this.errorPhone.error = false;
    }
  } 

  setPhoneCodeNumber(val: string) {
    this.phoneNumberCode = val;
  }

  validateCourierType() {
    this.error.courierType = !this.dataCourier.courierType;
    if (this.dataCourier.courierType) {
      this.filterPartnerList("");
    }
  }

  validateVehicleNumber() {
    this.error.vehiclePlate = validatePlateNumber(
      this.dataCourier.vehiclePlate
    );
  }

  validateBankAccount() {
    this.error.bankAccount = !/^.{10,16}$/.test(
      this.dataCourier.bank.bankAccount
    );
  }

  onSaveCourier() {
    if (this.isEdit) {
      this.showModal = true;
      this.isModalConfirmation = true;
      return;
    }
    this.onCreateCourier();
  }

  onCloseModal() {
    this.modalConfirmLogout = false;
    this.showModal = false;
  }

  async onCreateCourier() {
    this.onCloseModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      await CourierManagementController.createCourier(
        new ApiRequestCourierManagementCreate({
          payload: new CourierManagementDetail({
            ...this.dataCourier,
            phoneNumber: `${this.phoneNumberCode.substring(1)}${
              this.dataCourier.phoneNumber
            }`
          })
        })
      );
      this.showModal = true;
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("courierManagement.failedAddCourier") as string,
          this.onCreateCourier
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  async onEditCourier() {
    this.isModalConfirmation = false;
    this.onCloseModal();
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    try {
      await CourierManagementController.editCourier(
        new ApiRequestCourierManagementCreate({
          payload: new CourierManagementDetail({
            ...this.dataCourier,
            phoneNumber: `${this.phoneNumberCode.substring(1)}${
              this.dataCourier.phoneNumber
            }`
          })
        })
      );
      this.showModal = true;
    } catch (error) {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          error,
          this.$t("courierManagement.failedEditCourier") as string,
          this.onEditCourier
        )
      );
    } finally {
      MainAppController.closeLoading();
    }
  }

  goToWhatsapp() {
    if (this.dataCourier.phoneNumber) {
      const phoneFormat = this.dataCourier.phoneNumber.replace(/\+/g, "");
      window.open(
        `https://api.whatsapp.com/send?phone=${phoneFormat}`,
        "_blank"
      );
    }
  }

  onChecked() {
    this.dataCourier.courierIsCod = !this.dataCourier.courierIsCod;
  }

  formatLastActive(isoDate: string): string {
    const target = moment(isoDate).utcOffset(7); // +07:00
    const now = moment().utcOffset(7);

    const isToday = now.isSame(target, "day");
    const prefix = isToday
      ? (this.$t("courierManagement.lastActiveToday") as string)
      : `${this.$t("courierManagement.lastActiveAt") as string} ${target.format(
          "D MMM YYYY"
        )}`;

    return `${prefix}, ${target.format("H:mm")} WIB`;
  }

  eligibleListPerangkat() {
    return FlagsPermissionCourierManagement.permission_courier_management_eligible_device_connect.isEnabled();
  }

  onChangePartner(value: any) {
    if (value && this.partnerType === "pos") {
      this.partnerDataList = value;
      this.setActionDeliveryData(value);
    }
  }

  async setActionDeliveryData(value: any) {
    await this.fetchDetailPartner(value.id || 0);
    if (!this.isEdit && this.partnerDetail.partnerId) {
      this.dataCourier.courierAreaDeliveries = [
        new CourierDeliveries({
          cityCode: this.partnerDetail.partnerAreaDeliveries.length
            ? this.partnerDetail.partnerAreaDeliveries[0].cityCode
            : this.partnerDetail.partnerLocation.city.code,
          cityName: this.partnerDetail.partnerAreaDeliveries.length
            ? `${this.partnerDetail.partnerAreaDeliveries[0].cityCode}-${this.partnerDetail.partnerAreaDeliveries[0].cityName}`
            : `${this.partnerDetail.partnerLocation.city.code}-${this.partnerDetail.partnerLocation.city.name}`,
          districts: [
            new District({
              name: this.$t("courierManagement.all") as string,
              code: "ALL"
            })
          ]
        })
      ];
    }
  }
  get showAreaDelivery() {
    return (
      this.dataCourier.courierType === "POS" && this.partnerDetail.partnerId
    );
  }

  // get partner detail
  partnerDetail: PartnerDetail = new PartnerDetail();

  async fetchDetailPartner(id: number) {
    try {
      MainAppController.showLoading();
      const res = await PartnerController.fetchPartnerDetail({
        id: id,
        tieringLevel: false
      });
      this.partnerDetail = res;
      this.dataCourier.partnerOwnershipName = res.partnerOwnershipName || "-";
    } catch {
      this.partnerDetail = new PartnerDetail();
    } finally {
      MainAppController.closeLoading();
    }
  }

  // get partner 3lc
  partnerDataList = new ClientPartnerOptions();
  list3lc: any[] = [];
  listDistrict: any[] = [];

  getPartner3lc(item: any) {
    return new OptionsClass({
      name: item.cityCode ? `${item.cityCode}-${item.cityName}` : "",
      value: item.cityCode
    });
  }

  onSelect3lc(value: any, index: number) {
    if (value) {
      if (
        this.dataCourier.courierAreaDeliveries[index].cityCode !==
        value.cityCode
      ) {
        this.onClear3lc(index);
      }
      this.dataCourier.courierAreaDeliveries[index].cityCode = value.cityCode;
      this.dataCourier.courierAreaDeliveries[index].cityName = value.cityName;
    } else {
      this.onClear3lc(index);
    }
  }

  get filtered3lcData() {
    return this.partnerDetail.partnerAreaDeliveries
      .filter(
        (item) =>
          !this.dataCourier.courierAreaDeliveries
            .flatMap((itemCourier) => itemCourier.cityCode)
            .includes(item.cityCode)
      )
      .map((item) => {
        return {
          cityName: `${item.cityCode}-${item.cityName}`,
          cityCode: item.cityCode
        };
      });
  }

  onFocus3lc() {
    this.list3lc = this.filtered3lcData;
  }

  onFilter3lc(searchText: string, index: number) {
    const text = searchText.trim().toLowerCase();

    // If search empty → reset all options
    if (!text) {
      this.onSelect3lc("", index);
      this.list3lc = this.filtered3lcData;
      return;
    }

    this.list3lc = this.filtered3lcData.filter(
      (item) =>
        item.cityName.toLowerCase().includes(text) ||
        item.cityCode.toLowerCase().includes(text)
    );
  }

  onClear3lc(index: number) {
    this.dataCourier.courierAreaDeliveries[index].cityCode = "";
    this.dataCourier.courierAreaDeliveries[index].cityName = "";
    this.dataCourier.courierAreaDeliveries[index].districts = [];
  }

  get disableAddAreaDelivery() {
    const courierDataTotalData = this.dataCourier.courierAreaDeliveries.length;

    const anyDataEmpty = this.dataCourier.courierAreaDeliveries.some(
      (item: any) => {
        return !item?.cityCode || !item?.districts?.length;
      }
    );

    return (
      courierDataTotalData >= this.partnerDetail.partnerAreaDeliveries.length ||
      anyDataEmpty
    );
  }

  onFocusDistrict(index: number) {
    this.listDistrict = this.partnerDetail.partnerAreaDeliveries.find(
      (item) =>
        item.cityCode === this.dataCourier.courierAreaDeliveries[index].cityCode
    ).districts;
  }

  onFilterDistrict(searchText: string, index: number) {
    const text = searchText.trim().toLowerCase();
    const defaultDistrict = this.partnerDetail.partnerAreaDeliveries.find(
      (item) =>
        item.cityCode === this.dataCourier.courierAreaDeliveries[index].cityCode
    ).districts;
    // If search empty → reset all options
    if (!text) {
      this.listDistrict = defaultDistrict;
      return;
    }

    this.listDistrict = defaultDistrict.filter(
      (item: any) =>
        item.name.toLowerCase().includes(text) ||
        item.code.toLowerCase().includes(text)
    );
  }

  addAreaDelivery() {
    this.dataCourier.courierAreaDeliveries.push(new CourierDeliveries());
  }

  removeAreaDelivery(index: number) {
    this.dataCourier.courierAreaDeliveries.splice(index, 1);
  }

  get isKvpOrTruck() {
    return ["TRUCK", "KVP"].includes(this.dataCourier.courierType);
  }

  checkPreviousValue(index: number) {
    if (index === 0) {
      return false;
    }

    for (let i = 0; i < index; i++) {
      const prev = this.dataCourier.courierAreaDeliveries[i];

      // 1. cityCode empty?
      if (!prev.cityCode || prev.cityCode.trim() === "") {
        return true;
      }

      // 2. districts empty or undefined?
      if (!prev.districts || prev.districts.length === 0) {
        return true;
      }
    }
  }

  mapDistrictsName(districts: District[]) {
    return districts.map((district) =>
      String(district.code).toUpperCase() === "ALL"
        ? (this.$t("courierManagement.all") as string)
        : district.name
    );
  }
}
export default FormCourier;
